import { computed, Injectable, signal } from '@angular/core';
import { Ad6Service } from '@library/shared/service';
import { Ad6Constants } from '@shared/constants';
import { catchError, map, Observable, of, tap } from 'rxjs';

import { Event } from './event';

@Injectable({
  providedIn: 'root',
})
export class EventService extends Ad6Service<Event> {
  private events = signal<Event[]>([]);

  selectedEvent = computed<Event | undefined>(() => {
    const events = this.events();
    if (events) {
      return events.find(event => event.active);
    }
    return undefined;
  });

  constructor() {
    super(Ad6Constants.EVENT_ENDPOINT);
  }

  getActive(): Observable<Event | undefined> {
    if (this.selectedEvent()) {
      return of(this.selectedEvent());
    }

    return this.getList().pipe(
      tap(events => this.events.set(events)),
      map(() => this.selectedEvent()),
      catchError(() => of(undefined)),
    );
  }

  getSelectedEvent(): Event | undefined {
    return this.selectedEvent();
  }

  setEvent(eventUuid: string): void {
    this.events().map(e => {
      e.active = e.uuid === eventUuid;
      return e;
    });
  }
}
